import router from "../router";
import {types as subscriptionTypes} from "../store/modules/Project.module";
import store from "../store";
const afterLogin = function (user,project = {}){
	if (project.id) {
		store
			.dispatch(subscriptionTypes.CHECK_SUBSCRIPTION, {
				userId: user.id,
				projectHash: router.currentRoute.query.p
			})
			.then(response => {
				if (response.data.verify) {
					window.location = response.data.url;
				} else {
					router.push({
						name: "plans-view",
						query: {p: router.currentRoute.query.p}
					});
				}
			});
	} else {
		if (user.role === 0) {
			router.push({name: "main-dashboard"});
		} else if (user.role === 1) {
			router.push({name: "purchase-history"});
		}
	}
};
export default afterLogin;
